import { Box, Grid } from '@mui/material'
import { MaybeString } from '../../../utils'

interface VerticalTabNavTitleProps {
  date: MaybeString
  title: MaybeString
}

export const VerticalTabNavTitle = ({
  date,
  title
}: VerticalTabNavTitleProps) => {
  return (
    <Grid container alignItems="center">
      <Grid item md={9} xs={9}>
        <Box
          sx={{
            textAlign: 'left',
            fontSize: '16px',
            textTransform: 'capitalize'
          }}
        >
          {title}
        </Box>
      </Grid>
      <Grid item md={3} xs={3}>
        <Box sx={{ textAlign: 'right', color: '#7C7C7C', fontSize: '14px' }}>
          {date}
        </Box>
      </Grid>
    </Grid>
  )
}
